import { createRouter, createWebHistory } from 'vue-router'
import { isUnlocked } from '../utils/unlock'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home/index.vue')
  },
  {
    path: '/unlock',
    name: 'Unlock',
    component: () => import('../views/Unlock.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  },
  {
    path: '/dashboard',
    name: 'MyDashboard',
    component: () => import('../views/Dashboard.vue')
  },
  {
    path: '/canvas-effects',
    name: 'CanvasEffects',
    component: () => import('../views/canvas-effects/CanvasEffects.vue')
  },
  {
    path: '/shuangyuewan',
    name: 'ShuangYueWan',
    component: () => import('../views/shuangyuewan/ShuangYueWan.vue')
  },
  {
    path: '/guangzhou',
    name: 'GuangZhou',
    component: () => import('../views/guangzhou/GuangZhou.vue')
  },
  {
    path: '/heyuan-longchuan',
    name: 'HeYuanLongChuan',
    component: () => import('../views/heyuan/HeYuanLongChuan.vue')
  },
  {
    path: '/pets',
    name: 'PetList',
    component: () => import('../views/pet/PetList.vue')
  },
  {
    path: '/pet/:id',
    name: 'PetDetail',
    component: () => import('../views/pet/PetDetail.vue'),
    props: true
  },
  {
    path: '/taiji-bagua',
    name: 'TaiJiBagua',
    component: () => import('../views/taiji-bagua/TaiJiBagua.vue')
  },
  {
    path: '/star-compass',
    name: 'StarCompass',
    component: () => import('../views/star-compass/StarCompass.vue')
  },
  {
    path: '/tao-te-ching',
    name: 'TaoTeChing',
    component: () => import('../views/tao-te-ching/TaoTeChing.vue')
  },
  {
    path: '/css-fx-showcase',
    name: 'CSSFxShowcase',
    component: () => import('../views/css-fx-showcase/CSSFxShowcase.vue')
  },
  {
    path: '/lottery',
    name: 'Lottery',
    component: () => import('../views/Lottery.vue')
  },
  {
    path: '/emotion-palette',
    name: 'EmotionPalette',
    component: () => import('../views/emotion-palette/index.vue')
  },
  {
    path: '/ai-timeline',
    name: 'AiTimeline',
    component: () => import('../views/AiTimeline.vue')
  },
  {
    path: '/assets-showcase',
    name: 'AssetsShowcase',
    component: () => import('../views/assets-showcase/AssetsShowcase.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, _from, next) => {
  if (to.path === '/' || to.path === '/unlock') {
    next()
    return
  }
  if (!isUnlocked()) {
    next('/unlock')
    return
  }
  next()
})

export default router